import React from "react";


export default function smallFooter() {
    return (
      <footer id="footer" className="position-absolute w-100 bottom-0 flex-shrink-0 py-2 bg-dark text-white-50">
        <div className="container text-center">
          <small>Created by: Matt Neale | Contact: mattcdneale@gmail.com</small>
        </div>
      </footer>
    );
  
}